module.exports = __webpack_public_path__ + "static/media/about-17.b0880c28.webp";